import { Action } from '@ngrx/store';
import { Message } from './message.reducer';

export enum MessageActionTypes {
    Set = '[Message] set message'
}

export class SetMessage implements Action {
    public type = MessageActionTypes.Set;
    constructor(public payload: Message) { }
}

export type MessageActions = SetMessage;
